import { useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { useFileAnalysis } from "@/hooks/useFileAnalysis";
import { Message } from "@/types/chat";

export function useFileAnalysisHandler() {
  const [isAnalyzing, setIsAnalyzing] = useState(false);
  const { analyzeFile } = useFileAnalysis();
  const { toast } = useToast();

  const handleFileAnalysis = async (
    file: File, 
    currentConversationId: string | null,
    setMessages: (messages: Message[] | ((prev: Message[]) => Message[])) => void
  ) => {
    setIsAnalyzing(true);
    
    try {
      const analysis = await analyzeFile(file, currentConversationId || "current");
      
      if (analysis) {
        const systemMessage: Message = {
          id: crypto.randomUUID(),
          role: "assistant",
          content: `Jeg har analysert filen "${analysis.fileName}". Her er innholdet:\n\n${analysis.content}\n\nHva ønsker du å vite om dette dokumentet?`,
          created_at: new Date().toISOString()
        };
        
        setMessages(prev => [...prev, systemMessage]);
      }
      
      return analysis;
    } catch (error) {
      console.error('Error analyzing file:', error);
      toast({
        variant: "destructive",
        title: "Feil ved filanalyse",
        description: "Kunne ikke analysere filen. Vennligst prøv igjen.",
      });
      throw error;
    } finally {
      setIsAnalyzing(false);
    }
  };

  return {
    isAnalyzing,
    handleFileAnalysis
  };
}